/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { ChangeEventHandler } from 'react';
import HBCheckbox from '../HBCheckbox/HBCheckbox';
import { stopEventPropagation } from '../../utils/shared.utils';
import { CSSDimensionValue } from '../../tokens/types';

function HBTableCheckbox({
    checked,
    indeterminate,
    onChange,
    testIdName,
    margin
}: {
    checked: boolean;
    onChange: ChangeEventHandler<HTMLInputElement>;
    indeterminate?: boolean;
    testIdName: string;
    margin?: CSSDimensionValue;
}) {
    return (
        <div onClick={stopEventPropagation} onKeyPress={stopEventPropagation}>
            <HBCheckbox
                margin={margin}
                size="sm"
                testIdName={testIdName}
                checked={checked}
                onChange={onChange}
                indeterminate={indeterminate}
            />
        </div>
    );
}
export default HBTableCheckbox;
